import styled from "styled-components";
import { theme } from "../../../../styles/theme";

export const Container = styled.div``;

export const ActionsWrapper = styled.div`
  width: 128px;
  margin-top: 10px;

  gap: 6px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const Button = styled.button`
  width: 50px;
  height: 40px;
  max-width: 40px;
  max-height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
  border: 1px solid #FFCECE;
  background: ${theme.colors.white};
`;

export const TrashButton = styled(Button)`
  border-color: #FFCECE;

  & path {
    fill: ${theme.colors.erro};
  }
`;

export const PlusButton = styled(Button)`
  border-color: #E0E7FB;

  & path {
    fill: ${theme.colors.green3};
  }
`;
